export const applyPlantesFilters = (annonce, filters) => {
  const {
    typePlante = [],
    prixMin,
    prixMax,
  } = filters;

  const isTypePlanteFiltered =
    typePlante.length === 0 || typePlante.includes(annonce.typePlante);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= prixMin) &&
    (!prixMax || annonce.prix <= prixMax);

  return isTypePlanteFiltered && isPrixFiltered;
};